import { memo, useState, useMemo } from "react";
import { Table } from "antd";

const DataByDate = ({ data }) => {
    const [pageSize, setPageSize] = useState(31);

    const handleChange = (e) => {
        setPageSize(e.pageSize);
    };

    const convertCurrency = (value) => {
        return new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND"
        }).format(value || 0);
    };

    const tableData = useMemo(() => {
        if (!data?.result?.length) return [];

        const totalRow = {
            date: "Tổng",
            key: "summary",
            total_revenue: 0,
            total_count: 0
        };

        data.result.forEach((row) => {
            totalRow.total_revenue += Number(row.total_revenue || 0);
            totalRow.total_count += Number(row.total_count || 0);

            data.listStore.forEach((store) => {
                totalRow[`${store.id}_revenue`] =
                    (totalRow[`${store.id}_revenue`] || 0) +
                    Number(row[`${store.id}_revenue`] || 0);

                totalRow[`${store.id}_count`] =
                    (totalRow[`${store.id}_count`] || 0) +
                    Number(row[`${store.id}_count`] || 0);
            });
        });

        return [totalRow, ...data.result];
    }, [data]);

    const columns = useMemo(() => {
        if (!data?.listStore) return [];

        return [
            {
                title: "Ngày",
                dataIndex: "date",
                width: 130,
                fixed: "left"
            },
            {
                title: "Tổng",
                width: 170,
                fixed: "left",
                align: "center",
                render: (_, row) => (
                    <>
                        <div style={{ fontWeight: 600 }}>
                            {convertCurrency(row.total_revenue)}
                        </div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                            ({row.total_count})
                        </div>
                    </>
                )
            },

            ...data.listStore.map((store) => ({
                title: store.name_store,
                width: 170,
                align: "center",
                render: (_, row) => {
                    const revenue = row[`${store.id}_revenue`] || 0;
                    const count = row[`${store.id}_count`] || 0;

                    return (
                        <>
                            <div style={{ fontWeight: 600 }}>
                                {convertCurrency(revenue)}
                            </div>
                            <div style={{ fontSize: 12, color: "#888" }}>
                                ({count})
                            </div>
                        </>
                    );
                }
            }))
        ];
    }, [data]);

    if (!data) {
        return <div>Đang tải dữ liệu...</div>;
    }

    return (
        <div className="p-2 bg-white">
            <div className="mb-2 font-semibold">
                Bảng số liệu theo ngày
            </div>

            <Table
                rowKey={(row) => row.key || row.date}
                columns={columns}
                dataSource={tableData}
                bordered
                scroll={{ x: "max-content", y: 600 }}
                pagination={{
                    pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ["31", "62", "124"]
                }}
                onChange={handleChange}
                rowClassName={(row) =>
                    row.key === "summary"
                        ? "bg-yellow-100 font-bold"
                        : ""
                }
            />
        </div>
    );
};

export default memo(DataByDate);